export default __webpack_public_path__ + "b607d2fb4897966f90b68d3502888c6b.svg";